import { Text } from 'aos-ui/src/components/base/Text'
import { Color } from 'aos-ui-common/src/styles/Color'
import React, { FCWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Box } from '../../base/Box'
import { FileUpload } from '../../form/FileUpload'
import { SvgIcon } from '../../svg/SvgIcon'
import { SvgImage } from '../../svg/SvgImage'
import { AttachmentContainerItem } from './AttachmentContainerItem'
import { PreviewableProps } from './PreviewableProps'

interface AttachmentUploadProps extends PreviewableProps {
    onUpload(v: FileList): void
}

export const AttachmentUpload: FCWithChildren<AttachmentUploadProps> = ({ onUpload, ...rest }) => {
    const { t: translate } = useTranslation()
    const addText = 'Add'

    return (
        <AttachmentContainerItem {...rest}>
            <Box coverAll>
                <Box column coverAll centered>
                    <Box row>
                        <Image svg={SvgIcon.ZoomIn} />
                        <AddText>{addText}</AddText>
                    </Box>
                    <Text
                        textAlign='center'
                        paddingHorizontal={12}
                        size={11}
                        color={Color.TextDarkSecondary}
                    >
                        {`(${translate('allowed-file-types', { ns: 'events' })})`}
                    </Text>
                </Box>
                <FileUpload onChange={onUpload} />
            </Box>
        </AttachmentContainerItem>
    )
}

const Image = styled(SvgImage)`
    fill: ${Color.Tint};
`

const AddText = styled(Text)`
    font-size: 12px;
    color: ${Color.Tint};
    font-weight: 700;
`
